import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
  titleChip: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
    },
  },
}));

const GroupListMembership = ({ group, membership }) => {
  const classes = useStyles();

  if (group.found) {
    return null;
  }

  if (membership) {
    if (membership.role === 'OWNER') {
      return (
        <Chip
          label="Owner"
          size="small"
          color="primary"
          className={classes.titleChip}
        />
      );
    }
    if (membership.role === 'MEMBER') {
      return (
        <Chip
          label="Member"
          size="small"
          color="primary"
          variant="outlined"
          className={classes.titleChip}
        />
      );
    }
    if (membership.role === 'REQUESTED') {
      return (
        <Chip
          label="Requested"
          size="small"
          color="primary"
          variant="outlined"
          className={classes.titleChip}
        />
      );
    }
  }

  return null;
};

GroupListMembership.propTypes = {
  membership: PropTypes.object,
  group: PropTypes.object.isRequired,
};

export default GroupListMembership;